import { render, staticRenderFns } from "./Semiology.vue?vue&type=template&id=0f9b977a&"
import script from "./Semiology.vue?vue&type=script&lang=js&"
export * from "./Semiology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports